/*
 *
 * SignupParent constants
 *
 */

// LOAD
export const LOAD_SIGNUPPARENT = 'app/SignupParent/LOAD_SIGNUPPARENT';
export const LOAD_SIGNUPPARENT_SUCCESS =
  'app/SignupParent/LOAD_SIGNUPPARENT_SUCCESS';
export const LOAD_SIGNUPPARENT_ERROR =
  'app/SignupParent/LOAD_SIGNUPPARENT_ERROR';

// CHANGE/UPDATE
export const CHANGE_SIGNUPPARENT = 'app/SignupParent/CHANGE_SIGNUPPARENT';
export const CHANGE_SIGNUPPARENT_SUCCESS =
  'app/SignupParent/CHANGE_SIGNUPPARENT_SUCCESS';
export const CHANGE_SIGNUPPARENT_ERROR =
  'app/SignupParent/CHANGE_SIGNUPPARENT_ERROR';

// DELETE
export const DELETE_SIGNUPPARENT = 'app/SignupParent/DELETE_SIGNUPPARENT';
export const DELETE_SIGNUPPARENT_SUCCESS =
  'app/SignupParent/DELETE_SIGNUPPARENT_SUCCESS';
export const DELETE_SIGNUPPARENT_ERROR =
  'app/SignupParent/DELETE_SIGNUPPARENT_ERROR';

export const FLUSH_STATE_SIGNUPPARENT =
  'app/SignupParent/FLUSH_STATE_SIGNUPPARENT';
